import styled from "styled-components";

export const AboutContainer = styled.div`
    background-image: linear-gradient(to bottom, #434343, #3f3f3f, #3b3a3b, #373636, #333232, #333232, #333232, #333232, #373636, #3b3a3b, #3f3f3f, #434343);
    background-position: center;
    background-size: cover;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;   
    text-align: center;
    line-height: 1.6;
    word-wrap: break-word;
    @media only screen and (max-width: 600px){
        width:100%;
    } 
    `;
    export const AboutH1 = styled.h1`
    padding-top: 12px;
    font-size: clamp(1rem, 10vw, 4rem);
    font-family: 'Source Code Pro', monospace;
    word-wrap: break-word;
    color: #4AF626;
    margin-bottom: 1rem;
    letter-spacing: 3px;
    text-shadow:
   -1px -1px 0 #000,  
    1px -1px 0 #000,
    -1px 1px 0 #000,
     1px 1px 0 #000;
    `;
    export const ImgContainer = styled.div`
    font-size: clamp(1rem, 10vw, 2rem);
    font-family: 'Source Code Pro', monospace;
    margin-bottom: 1rem;
    margin-right:15px;
    float: left;
    .img{
        display: block;
    }
    padding-left: 20px;
    @media only screen and (max-width: 600px){
        width: 100%;
        padding-left: 5px;
    }
    `;

    export const AboutH3 = styled.h3`
    font-size: clamp(1rem, 10vw, 1rem);
    font-family: 'Source Code Pro', monospace;
    color: #4AF626;
    margin-bottom: 1rem;
    letter-spacing: 1px;
    padding-left: 15px;
    margin-left: 310px
    align-items: center;
    justify-content: center;   
    text-align: justify;
    text-shadow:
   -1px -1px 0 #000,  
    1px -1px 0 #000,
    -1px 1px 0 #000,
     1px 1px 0 #000;
    @media only screen and (max-width: 600px){
        width: 90%;
        padding-left: 30px;
        padding-right: 0px;
    }
    `;

    export const Wrapper = styled.div`
    
    margin: 20px 20px 0 0;  
    overflow: auto
    display: flex;
    justify-content:center;
    `;

    export const AboutH4 = styled.h3`
        font-size: clamp(1rem, 10vw, 1.5rem);
        font-family: 'Source Code Pro', monospace;
        color: #4AF626;
        margin-bottom: 1rem;
        text-align: justify;
        letter-spacing: 2px;
        text-shadow:
   -1px -1px 0 #000,  
    1px -1px 0 #000,
    -1px 1px 0 #000,
     1px 1px 0 #000;
        @media only screen and (max-width: 600px){
            font-size: 24px;
        }
        `;

    
